<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#YTTopBar" aria-controls="YTTopBar" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button> -->
    <a class="navbar-brand" href="#">YTeach Admin Portal</a>

    <div class="collapse navbar-collapse" id="YTTopBar">
      <!-- <div class="flex-shrink-1 ml-auto mr-auto"> -->
      <div v-if="userProfile && userProfile.role === 'superadmin'" class="row ml-auto align-items-center">
        <label class="col-auto mb-0">Filter by School:</label>
        <div class="col-auto">
          <b-form-select v-model="selected" :options="schoolOptions" @change="onChangeSchool">
            <template slot="first">
              <option :value="null">All Schools</option>
            </template>
          </b-form-select>
        </div>
      </div>

      <b-nav v-if="isAuthenticated && userProfile" class="ml-auto flex-shirnk-1">
        <b-nav-item-dropdown right>
          <template slot="text">
            <i class="fas fa-user-circle"></i> {{ userProfile.username }}
          </template>
          <b-dropdown-item @click="logout()">Logout</b-dropdown-item>
          <!-- <b-dropdown-divider></b-dropdown-divider> -->
        </b-nav-item-dropdown>
      </b-nav>
    </div>
  </nav>
</template>

<script>
  import Vue from 'vue'
  import { Component, Prop } from 'vue-property-decorator'
  import { namespace } from 'vuex-class'

  const appModule = namespace('app')

  @Component()
  export default class TopBar extends Vue {
    @appModule.Mutation('setFilterBySchool') mutationFilterBySchool

    @Prop({
      type: Boolean,
      default: false
    })
    isAuthenticated

    @Prop({
      type: Object,
      default: () => { }
    })
    userProfile

    @Prop({
      type: Array,
      default: () => []
    })
    schools

    selected = null

    onChangeSchool(value) {
      value && value.id ? localStorage.setItem('schoolId', value.id) : localStorage.removeItem('schoolId');
      this.mutationFilterBySchool(value)
    }

    logout() {
      this.$emit('logout')
    }

    get schoolOptions() {
      return this.schools.map(item => {
        return { value: item, text: item.name }
      })
    }

    mounted() {
      //localStorage.setItem('username', this.userProfile.username)
    }
  }
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/common/TopBar.vue